import { render, staticRenderFns } from "./confirmDisplay.vue?vue&type=template&id=c6d5f6ce&scoped=true"
import script from "./confirmDisplay.vue?vue&type=script&lang=js"
export * from "./confirmDisplay.vue?vue&type=script&lang=js"
import style0 from "./confirmDisplay.vue?vue&type=style&index=0&id=c6d5f6ce&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d5f6ce",
  null
  
)

export default component.exports